export default {
  OK: "OK",
  ok: "ok",
  loginFailed: "Не удалось войти в систему, пожалуйста, повторите попытку.",
  requestFailed: "Запрос не удался, пожалуйста, проверьте подключение к интернету.",
  invalidLogin: "Неверное имя пользователя или пароль.",
  thisFunctionExists: "Эта функция уже существует.",
  thisFunctionNotAllowDelete: "Эту функцию нельзя удалить.",
  thisFunctionNotExists: "Этой функции не существует.",
  targetFunctionIdRequired: "Требуется идентификатор целевой функции.",
  thisPageExists: "Эта страница уже существует.",
  thisPageNotAllowDelete: "Эту страницу нельзя удалять.",
  thisRoleExists: "«Эта роль уже существует».",
  thisRoleNotAllowDelete: "Эту роль нельзя удалять.",
  targetRoleIdRequired: "Требуется идентификатор целевой роли.",
  invalidParameter: "Неверный параметр.",
  systemError: "Система не может обработать ваш запрос.",
  spErrorMessage: "Ошибка сообщения SP (Зависит от какой ошибки).",
  actionbyRequired: "Текущий пользователь обязателен.",
  sessionTokenRequired: "Требуется токен сессии.",
  functionIdRequired: "Требуется идентификатор функции.",
  functionNameRequired: "Имя функции является обязательным.",
  newFunctionNameRequired: "Имя функции является обязательным.",
  pageIdRequired: "Требуется ID страницы.",
  newPageIdRequired: "Требуется ID страницы.",
  newPageNameRequired: "Имя страницы обязательно.",
  targetPageIdRequired: "Требуется идентификатор целевой страницы.",
  passwordRequired: "Пароль обязателен.",
  userNameRequired: "«Требуется полное имя.»",
  passwordValidation: "Пароль должен состоять из 6-20 символов и состоять из комбинации цифр и букв.",
  pageNumRequired: "Номер страницы обязателен.",
  pageSizeRequired: "Размер страницы обязателен.",
  roleIdRequired: "Требуется идентификатор роли",
  oldPasswordRequired: "Требуется текущий пароль.",
  userStatusRequired: "Статус пользователя обязателен.",
  newRoleIdRequired: "Требуется идентификатор роли.",
  newRoleNameRequired: "Имя роли является обязательным.",
  startDateIsGteEndDate: "Дата начала больше, чем дата окончания.",
  thisRoleNotExists: "Этой роли не существует.",
  thisPageNotExists: "Эта страница не существует.",
  thisUserExists: "«Этот Пользователь уже существует.»",
  thisUserNotExists: "Этот Пользователь не существует.",
  thisUserBlackListed: "Ваш аккаунт заблокирован.",
  thisUserInactive: "Ваша учетная запись отключена.",
  thisUserBlocked: "Ваш аккаунт заблокирован.",
  thisUserNotActive: "Ваша учетная запись отключена.",
  InvalidPageFunction: "Неверная функция страницы.",
  invalidUser: "Неверный пользователь!",
  invalidToken: "Недействительная сессия!",
  NoUserAccessRight: "«В разрешении отказано!»",
  connection: "«Ошибка подключения»",
  profileIdRequired: "Требуется ID профиля.",
  packageIdRequired: "Требуется идентификатор пакета.",
  fullNameMinThreeChar: "ФИО должно содержать не менее 3 символов.",
  accountIdMinThreeChar: "Идентификатор учетной записи должен содержать не менее 3 символов.",
  searchCriteriaRequired: "Критерии поиска обязательны для заполнения.",
  affiliateIdRequired: "Требуется партнерский ID.",
  minDepositRequired: "Требуется минимальный депозит.",
  bonusRateRequired: "Требуется бонусная ставка.",
  onlyAllowRejectDeposit: "Разрешить только отклонение депозитного билета.",
  senderBankIdRequired: "Требуется идентификатор банка отправителя.",
  senderBankAccNoRequired: "Номер счета банка отправителя. обязателен.»",
  minFTDAmtNumOnly: "Min. FTD Amt принимает только цифры.",
  maxFTDAmtNumOnly: "Max. FTD Amt принимает только числа.",
  crmBasicCriteriaRequired: "Требуется идентификатор участника / Контактный телефон / Контактный адрес электронной почты / Дата регистрации / Дата последнего входа в систему.",
  verifiedDateRangeAllowThreeMonths: "Диапазон дат регистрации позволяет выбрать только до 3 месяцев.",
  lastLoginDateRangeAllowThreeMonths: "Диапазон дат последнего входа в систему позволяет выбрать только до 3 месяцев.",
  depositDateRangeAllowThreeMonths: "Диапазон дат депозита позволяет выбрать только до 3 месяцев.",
  ftdDateRangeAllowThreeMonths: "Диапазон дат FTD позволяет выбрать только до 3 месяцев.",
  ltdDateRangeAllowThreeMonths: "Диапазон дат LTD позволяет выбрать только до 3 месяцев.",
  lastLoginDateEarlierThanVerifiedDate: "Дата последнего входа в систему раньше даты регистрации.",
  depositDateEarlierThanVerifiedDate: "Дата депозита раньше, чем дата регистрации.",
  ftdDateEarlierThanVerifiedDate: "Дата FTD раньше, чем дата регистрации.",
  ltdDateEarlierThanVerifiedDate: "«Дата LTD раньше даты регистрации.»",
  ftdFromRequired: "FTD с даты обязателен.",
  ftdToRequired: "FTD на сегодняшний день требуется.",
  ltdFromRequired: "LTD с даты обязателен.",
  ltdToRequired: "LTD на сегодняшний день обязателен.",
  failedToLaunchPaymentGateway: "Не удалось запустить платежный шлюз.",
  enTitleRequired: "Требуется EN Title.",
  enBodyRequired: "EN Body is required.",
  enImageUrlRequired: "EN Image Url обязателен.",
  enImageUrlDesktopRequired: "EN требуется URL-адрес образа рабочего стола.",
  enAltRequired: "EN Alt обязателен.",
  enHrefRequired: "EN Href обязателен.",
  resubmitTicketRequired: "Требуется повторная отправка билета.",
  withtholdBonusAndAmountGreaterThanZero: "«Удержание бонуса и удержание суммы не могут превышать нуля одновременно».",
  maxWithdrawMultipleAndAmountGreaterThanZero: "Максимальная сумма снятия не может превышать нуля одновременно.",
  serverBusy: "«Сервер сейчас занят. Пожалуйста, попробуйте еще раз».",
  isRequired: "Пожалуйста, введите {fname}.",
  isMinValue: "{fname} должно иметь минимальное значение {fvalue}.",
  isMaxValue: "{fname} должно быть меньше или равно {fvalue}.",
  isMinLength: "{fname} должно содержать не менее {fvalue} символов.",
  isMaxLength: "{fname} должно быть меньше или равно символам {fvalue}.",
  isAlpha: "{fname} принимать только алфавит.",
  isAlphaNum: "{fname} принимать только буквенно-цифровые данные.",
  isNumeric: "{fname} принимать только числа.",
  isEmail: "{fname} принимать только действительные адреса электронной почты.",
  isIpAddress: "{fname} принимать только действительные IPv4-адреса.",
  isSameAs: "{fname} должно быть таким же, как {fname2}.",
  isUrl: "{fname} принимают только URL-адреса.",
  containAlphaNum: "{fname} должен иметь хотя бы один алфавит и одну цифру.",
  alphaNumWithSpace: "{fname} принимать только буквенно-цифровые данные.",
  isDecimal: "{fname} принимать только числа.",
  isInteger: "{fname} принимать только целые числа.",
  selectOption: "Пожалуйста, выберите {fname}",
  notSameAs: "{fname} и {fname2} не могут быть одним и тем же.",
  dateRangeAllowOneMonth: "Диапазон дат позволяет выбрать только до 1 месяца.",
  dateRangeAllowOneYear: "Диапазон дат позволяет выбрать только до 1 года.",
  greaterThanZero: "{fname} должно быть больше нуля.",
  atLeastOneAuthority: "Должен выбрать по крайней мере один орган.",
  BLOCK: "Ваш аккаунт заблокирован.",
  SUSPEND: "Ваш аккаунт заблокирован.",
  CLOSE: "Ваш аккаунт закрыт.",
  RESETL: "Ваша учетная запись была сброшена.",
  atLeastOneProvider: "Необходимо выбрать хотя бы одного провайдера.",
  failedToGetResultUrl: "Не удалось получить URL результата.",
  fileSizeValidation: "Слишком большой, максимально допустимый размер - 1 мб",
  atLeastOnePaymentOption: "Необходимо выбрать хотя бы один вариант оплаты.",
  atLeastOnePaymentGateway: "Необходимо выбрать хотя бы один платежный шлюз.",
  dateRangeAllow31Days: "Диапазон дат позволяет выбрать только до 31 дня.",
  dateRangeAllow31Months: "Диапазон дат позволяет выбрать только до 31 месяца.",
  dateRangeAllow31Years: "Диапазон дат позволяет выбрать только до 31 года.",
  invalidCategory: "Недействительная категория.",
  noChanges: "Без изменений.",
  permissionDenied: "В разрешении отказано.",
  referralCodeRequired: "Реферальный код обязателен.",
  providerDescRequired: "Описание провайдера обязательно.",
  marqueeContentRequired: "Требуется содержимое марки.",
  bonusNameRequired: "Имя бонуса обязательно.",
  baseAmountRequired: "«Требуется базовая сумма.»",
  reviewIdRequired: "Требуется идентификатор проверки.",
  surveyIdRequired: "Требуется идентификатор опроса.",
  questionRequired: "Вопрос обязателен.",
  iframeIdRequired: "Требуется идентификатор iframe.",
  bonusAmountRequired: "«Требуется сумма бонуса.»",
  inboxIdRequired: "«Требуется идентификатор папки«Входящие».»",
  exchangedAmountRequired: "«Обмененная сумма обязательна.»",
  baseRateRequired: "«Требуется базовая ставка.»",
  exchangeRateRequired: "«Обменный курс обязателен.»",
  baseCurrencyRequired: "Требуется базовая валюта.",
  exchangeCurrencyRequired: "«Обмен валюты обязателен.»",
  depositTypeRequired: "«Требуется тип депозита.»",
  nbRedepositRequired: "Nb redeposit redeposit.",
  bankOwnerRequired: "«Требуется владелец банка.»",
  autoSenderRequired: "Требуется автоматический отправитель.",
  isRecommendRequired: "Рекомендуется обязательно.",
  recipientBankIdRequired: "Требуется идентификатор банка получателя.",
  recipientBankAccNoRequired: "Номер банковского счета получателя обязателен.",
  accountBalanceRequired: "Требуется остаток на счете.",
  incomingAmountThresholdRequired: "Порог входящей суммы обязателен.",
  incomingFrequencyThresholdRequired: "Порог входящей частоты обязателен.",
  outgoingAmountThresholdRequired: "Требуется порог исходящей суммы.",
  outgoingFrequencyThresholdRequired: "Требуется порог исходящей частоты.",
  bankAccTypeRequired: "«Требуется тип банковского счета.»",
  packageRequired: "«Пакет обязателен.»",
  rtpRequired: "«RTP обязателен.»",
  domainIdRequired: "Требуется ID домена.",
  buyOnBehalfRequired: "«Покупка от имени обязательна»",
  serviceProviderRequired: "«Требуется поставщик услуг.»",
  serverAccountRequired: "Требуется учетная запись сервера.",
  nameServerRequired: "Требуется сервер имен.",
  socialLinkRequired: "Социальная ссылка обязательна.",
  newSocialPlatformRequired: "«Требуется новая социальная платформа»",
  attachmentPathRequired: "Требуется путь крепления.",
  depositMethodRequired: "«Требуется способ депозита.»",
  depositDateRequired: "«Требуется дата внесения депозита.»",
  refNoRequired: "Требуется номер ссылки.",
  withdrawalAmountRequired: "«Требуется сумма вывода.»",
  targetBankAccNoRequired: "«Требуется номер целевого банковского счета.»",
  targetBankIdRequired: "Требуется идентификатор целевого банка.",
  jsonRatingRequired: "Рейтинг JSON обязателен.",
  startTimeRequired: "«Требуется время запуска.»",
  accountIdRequired: "Требуется ID учетной записи.",
  parentIdRequired: "Требуется идентификатор родителя.",
  amountRequired: "«Сумма обязательна.»",
  clientIpRequired: "Требуется IP-адрес клиента.",
  auditByRequired: "«Аудит обязателен.»",
  systemTypeRequired: "Тип системы обязателен.",
  currencyRequired: "«Валюта обязательна.»",
  ipAddressRequired: "«IP-адрес обязателен.»",
  affiliateCodeRequired: "Партнерский код обязателен.",
  contactPhoneRequired: "«Контактный телефон обязателен.»",
  requestTypeRequired: "Тип запроса обязателен.",
  securityDisabledRequired: "Требуется отключение безопасности.",
  gameCodeRequired: "Требуется код игры.",
  seqRequired: "Последовательность обязательна.",
  minLimitRequired: "«Требуется минимальный лимит.»",
  maxLimitRequired: "Требуется максимальный лимит.",
  commSportsRequired: "«Комиссия за спорт обязательна.»",
  commSlotsRequired: "«Комиссия за слоты обязательна.»",
  commLivecasinoRequired: "«Комиссия за лайв казино обязательна.»",
  commCockfightRequired: "Комиссия за петушиные бои обязательна.",
  commOthersRequired: "Комиссия за других обязательна.",
  settingValueRequired: "Установка значения обязательна.",
  vipIdRequired: "«Требуется VIP ID.»",
  carryOverRequired: "Перенос обязателен.",
  campaignIdRequired: "Требуется идентификатор кампании.",
  titleRequired: "Титул обязателен.",
  bodyRequired: "«Тело обязательно.»",
  itemOrderRequired: "Заказ товара обязателен.",
  imageUrlRequired: "URL изображения обязателен.",
  bannerIdRequired: "Требуется ID баннера.",
  directionRequired: "«Требуется указание.»",
  defaultOrderRequired: "Требуется заказ по умолчанию.",
  altRequired: "Альтернативный текст обязателен.",
  hrefRequired: "Требуется Хреф.",
  targetWindowRequired: "Целевое окно обязательно.",
  loginRequiredRequired: "Требуется вход в систему.",
  activeFromRequired: "Active from is required.",
  activeToRequired: "Active to is required.",
  bannerTypeRequired: "Тип баннера обязателен.",
  pageNameRequired: "Имя страницы обязательно.",
  remarkRequired: "Ремарка обязательна.",
  settingKeyRequired: "Ключ настройки обязателен.",
  memberListRequired: "Список участников обязателен.",
  workingMonthRequired: "«Требуется рабочий месяц.»",
  workingDateRequired: "«Требуется рабочая дата.»",
  tacRequired: "Правила и условия обязательны.",
  paymentModeRequired: "«Требуется режим оплаты.»",
  newPasswordRequired: "Требуется новый пароль.",
  loginIdRequired: "Требуется идентификатор для входа.",
  securityTagRequired: "«Требуется защитная бирка.»",
  securityCodeRequired: "«Требуется код безопасности.»",
  providerCodeRequired: "Требуется код провайдера.",
  startDateRequired: "Дата начала обязательна.",
  endDateRequired: "«Требуется дата окончания.»",
  searchIdRequired: "Требуется идентификатор поиска.",
  authTokenRequired: "Требуется токен аутентификации.",
  newStatusRequired: "«Требуется новый статус.»",
  actionRequired: "«Необходимы действия».",
  promotionIdRequired: "«Требуется идентификатор акции.»",
  promotionNameRequired: "Название акции обязательно.",
  rolloverRequired: "Требуется пролонгация.",
  criteriaRequired: "Критерии обязательны.",
  ticketIdRequired: "Требуется ID билета.",
  resultIdRequired: "Требуется идентификатор результата.",
  bankIdRequired: "Требуется банковский идентификатор.",
  bankAccNoRequired: "«Номер банковского счета обязателен.»",
  bankAccHolderRequired: "«Требуется владелец банковского счета».",
  newBankIdRequired: "Требуется новый банковский идентификатор.",
  newBankAccNoRequired: "Требуется новый номер банковского счета.",
  newBankAccHolderRequired: "Требуется новый владелец банковского счета.",
  fullNameRequired: "«Полное имя обязательно.»",
  depositAmountRequired: "«Требуется сумма депозита.»",
  gatewayAccRequired: "Требуется учетная запись шлюза.",
  labelNameRequired: "Имя этикетки обязательно.",
  labelIdRequired: "Требуется идентификатор этикетки.",
  bankTypeRequired: "«Требуется тип банка.»",
  amountLimitRequired: "«Требуется ограничение суммы.»",
  currencyRateRequired: "«Курс валюты обязателен.»",
  urlRequired: "URL обязателен.",
  cashRequired: "«Требуются наличные»",
  csRequired: "«Требуется поддержка клиентов.»",
  vipNameRequired: "«Требуется VIP-имя.»",
  campaignNameRequired: "Название кампании является обязательным.",
  transferIdRequired: "«Требуется ID перевода.»",
  betTimeRequired: "Требуется время ставки.",
  turnoverRequired: "«Оборот обязателен».",
  payoutRequired: "«Выплата обязательна.»",
  winloseRequired: "Выиграл/Проигрыш обязателен.",
  rawMessageRequired: "Требуется необработанное сообщение.",
  authStatusRequired: "Требуется статус авторизации.",
  dateRequired: "«Дата обязательна.»",
  betIdRequired: "Требуется ID ставки.",
  betStatusRequired: "Статус ставки обязателен.",
  betAmountRequired: "Сумма ставки обязательна.",
  isParlayRequired: "Требуется ли экспресс.",
  isAddonRequired: "Требуется ли аддон.",
  withholdBonusRequired: "Требуется бонус за удержание.",
  withholdAmountRequired: "«Требуется удержание суммы.»",
  maxWithdrawAmountRequired: "Требуется максимальная сумма вывода.",
  betTypeRequired: "Тип ставки обязателен.",
  maxWithdrawMultipleRequired: "Требуется максимальное снятие мультипликаторов.",
  socialPlatformRequired: "«Социальная платформа обязательна.»",
  vipProviderRebateRequired: "«Требуется скидка от VIP-провайдера.»",
  selfRebateRateRequired: "Ставка самостоятельной скидки обязательна.",
  downlineRebateRateRequired: "Требуется ставка рибейта нижестоящей структуры.",
  tierIdRequired: "Требуется идентификатор уровня.",
  rebateRateRequired: "Требуется ставка рибейта.",
  paymentGatewayRequired: "«Платежный шлюз обязателен.»",
  rescueIdRequired: "Требуется спасательный ID.",
  rescueNameRequired: "Спасательное имя обязательно.",
  rescueCycleRequired: "«Необходим цикл спасения.»",
  minLoseRequired: "«Требуется минимальный проигрыш.»",
  rescueRateRequired: "«Требуется скорость спасения.»",
  maxPayoutRequired: "Требуется максимальная выплата.",
  payoutMethodRequired: "«Требуется способ выплаты.»",
  targetGroupRequired: "«Требуется целевая группа.»",
  maintainDepositRequired: "Требуется поддерживать депозит.",
  maintainTurnoverRequired: "«Поддержание текучести обязательно.»",
  depositOrTurnoverRequired: "«Требуется депозит или оборот.»",
  maintainDepositOrMaintainTurnoverRequired: "«Требуется сохранить депозит или сохранить оборот».",
  vipListRequired: "VIP список обязателен.",
  gameNameRequired: "Название игры обязательно.",
  claimTypeRequired: "Тип претензии обязателен.",
  operatorIdRequired: "Требуется ID оператора.",
  maxBonusRequired: "Максимальный бонус обязателен.",
  endTimeRequired: "«Требуется время окончания.»",
  mondayRequired: "«Понедельник обязателен.»",
  tuesdayRequired: "«Вторник обязателен».",
  wednesdayRequired: "«Среда обязательна».",
  thursdayRequired: "«Четверг обязателен.»",
  fridayRequired: "«Пятница обязательна.»",
  saturdayRequired: "«Суббота обязательна».",
  sundayRequired: "«Воскресенье обязательно.»",
  promotionTypeRequired: "Тип акции обязателен.",
  claimLimitRequired: "«Требуется лимит претензий.»",
  bonusRate1Required: "«Требуется бонусная ставка 1.»",
  bonusRate1To2Required: "Требуется бонусная ставка от 1 до 2.",
  bonusRate1To3Required: "Требуется бонусная ставка от 1 до 3.",
  bonusRate1To4Required: "Требуется бонусная ставка от 1 до 4.",
  bonusRate1To5Required: "Требуется бонусная ставка от 1 до 5.",
  bonusRate1To6Required: "Требуется бонусная ставка от 1 до 6.",
  bonusRate1To7Required: "Требуется бонусная ставка от 1 до 7.",
  externalIdRequired: "Требуется внешнее удостоверение личности.",
  opsiteRequired: "Opsite обязателен.",
  opsiteContentRequired: "«Требуется контент на сайте.»",
  opsiteLanguageRequired: "Требуется правильный язык.",
  opsitePaymentRequired: "«Требуется оплата за работу.»",
  opsiteProviderRequired: "Требуется поставщик услуг сайта.",
  opsiteProviderGamesRequired: "Требуется Opsite provider games.",
  accountTypeRequired: "Тип учетной записи обязателен.",
  domainNameRequired: "Доменное имя обязательно.",
  settledTimeRequired: "«Требуется установленное время».",
  validTurnoverRequired: "«Требуется действительный оборот.»",
  resultTimeRequired: "«Требуется время на результат.»",
  resultStatusRequired: "Статус результата обязателен.",
  secondIdRequired: "Требуется второе удостоверение личности.",
  domainListRequired: "Список доменов обязателен.",
  domainTypeRequired: "Тип домена обязателен.",
  moduleRequired: "Модуль обязателен.",
  gameIdRequired: "Требуется игровой идентификатор.",
  gameDetailRequired: "Детали игры обязательны.",
  bonusRate1To8Required: "Требуется бонусная ставка от 1 до 8.",
  bonusRate1To9Required: "Требуется бонусная ставка от 1 до 9.",
  bonusRate1To10Required: "Требуется бонусная ставка от 1 до 10.",
  invalidOrder: "Неверный заказ.",
  bannerNotExists: "«Баннера не существует».",
  invalidBannerType: "Неверный тип баннера.",
  pageNameExists: "Имя страницы существует.",
  pageNotExists: "Страница не существует.",
  tacIsValid: "OTP действует.",
  invalidTac: "Недействительный одноразовый пароль.",
  tacExpired: "«Срок годности OTP истек.»",
  tacNotValidate: "OTP не проверен.",
  paymentModeNotExists: "«Платежного режима не существует.»",
  paymentOptionProviderNotExists: "Поставщик платежных опций не существует.",
  ipAddressExists: "IP-адрес существует.",
  ticketProcessed: "Билет обработан.",
  bankAccountNotExists: "«Банковского счета не существует».",
  bankAccountInactive: "«Банковский счет неактивен.»",
  bankMemberNotExists: "«Участника банка не существует».",
  bankMemberInactive: "«Участник банка неактивен.»",
  affiliateExists: "Партнер существует.",
  contactPhoneExists: "«Контактный телефон существует.»",
  affiliateFull: "Партнер полный.",
  uplineInactive: "Вышестоящий неактивен.",
  applicationProcessed: "«Заявка обработана.»",
  tacValidated: "Правила и условия подтверждены.",
  applicationPending: "Заявка находится на рассмотрении.",
  favouriteGameExists: "«Любимая игра существует.»",
  invalidLimit: "Недействительный лимит.",
  settingNotSet: "Настройка не установлена.",
  domainNameNotExists: "«Доменное имя не существует».",
  domainNameFull: "Доменное имя заполнено.",
  domainNameNotAvailable: "Доменное имя недоступно.",
  domainNameExists: "Доменное имя существует.",
  subAccountNotExists: "«Субсчет не существует».",
  settingNotExists: "Настройка не существует.",
  invalidContactEmail: "Неверный контактный адрес электронной почты.",
  accountInactive: "Аккаунт неактивен.",
  campaignNotExists: "«Кампании не существует».",
  paymentProviderNotExists: "«Платежный провайдер не существует».",
  profileInactive: "Профиль неактивен.",
  minWithdrawalNotMet: "«Минимальный вывод средств не достигнут».",
  invalidBankId: "Недействительный банковский идентификатор.",
  bankAccountExists: "«Банковский счет существует.»",
  bankAccountFull: "«Банковский счет полон.»",
  bankAccHolderNotSame: "«Владелец банковского счета не один и тот же»",
  exceedMaxWithdrawal: "Превышает максимальный вывод средств.",
  exceedWithdrawalFrequency: "Превышает частоту вывода.",
  invalidPackage: "Неверная упаковка.",
  promotionNotAvailable: "«Акция недоступна.»",
  ongoingPromotion: "«Постоянное продвижение».",
  pendingResultInGame: "Ожидаемый результат в игре.",
  labelNameExists: "Имя лейбла существует.",
  labelNotExists: "Лейбл не существует.",
  invalidFtdMin: "Недействительный минимальный первоначальный депозит.",
  invalidFtdMax: "Недействительный максимальный первый депозит.",
  ftdMinGtFtdMax: "«Минимальный первоначальный взнос больше максимального.»",
  vipFull: "VIP полный",
  invalidRewardType: "Неверный тип награды.",
  vipExists: "VIP существует.",
  vipNotExists: "VIP не существует.",
  onlyOneMaxWithdrawSetting: "Разрешен только один максимальный вывод средств.",
  onlyOneWithholdSetting: "Разрешена только одна настройка удержания.",
  campaignExists: "«Кампания существует».",
  vipProviderNotExists: "«VIP-провайдера не существует»",
  turnoverTierExists: "«Уровень оборота существует.»",
  turnoverTierFull: "Уровень оборота превышает максимальный уровень.",
  turnoverTierNotExists: "«Оборотного уровня не существует.»",
  invalidSettingValue: "Неверное значение настройки.",
  turnoverTierNotSet: "Уровень оборота не установлен.",
  rebateProcessed: "Рибейт обработан.",
  invalidActionType: "Недопустимый тип действия.",
  invalidRescueCycle: "Неверный цикл спасения.",
  invalidPayoutMethod: "Неверный способ выплаты.",
  invalidTargetGroup: "Неверная целевая группа.",
  rescueExists: "«Спасение существует».",
  rescueNotExists: "«Спасения не существует».",
  walletExists: "«Кошелек существует.»",
  accountExists: "«Учетная запись существует.»",
  activeFromGtActiveTo: "Активный от большего чем активный до.",
  accountNotExists: "Идентификатор оператора не существует.",
  invalidDeposit: "Недействительный депозит.",
  invalidTurnover: "«Недействительный оборот.»",
  providerCodeNotExists: "Код провайдера не существует.",
  gameNameExists: "Название игры существует.",
  gameNameNotExists: "Название игры не существует.",
  invalidAccountType: "Неверный тип учетной записи.",
  invalidLoginIdFormat: "Неверный формат идентификатора входа.",
  invalidReferralCode: "Неверный реферальный код.",
  firstDepositNotMet: "Первый депозит не выполнен.",
  newbieNotMet: "«Требования новичка не выполнены.»",
  claimPromoOnlyOnce: "«Подайте заявку на повышение только один раз»",
  promotionRequirementNotMet: "«Требование о продвижении не выполнено»",
  withdrawalAmountLteWithholdAmount: "«Сумма снятия меньше или равна сумме удержания.»",
  subAccountInactive: "Субаккаунт неактивен.",
  gameNotSupported: "Игра не поддерживается.",
  startTimeGteEndTime: "Время начала больше или равно времени окончания.",
  invalidPromotionType: "Неверный тип акции.",
  invalidClaimType: "Недопустимый тип претензии.",
  claimLimitExceeded10: "«Лимит претензий превысил 10.»",
  verificationFailed: "«Верификация не прошла».",
  claimLimitReached: "«Достигнут лимит претензий.»",
  invalidPromotion: "«Недействительная акция.»",
  socialPlatformExists: "«Социальная платформа существует.»",
  duplicateReview: "«Дубликат отзыва.»",
  invalidSurveyId: "Неверный идентификатор опроса.",
  accountNotBlock: "Аккаунт не заблокирован.",
  walletNotExists: "«Кошелька не существует».",
  socialPlatformNotExists: "«Социальной платформы не существует».",
  socialPlatformInactive: "Theme name is required,",
  accountSocialExists: "Theme color is required",
  invalidStatus: "Language is required",
  samePassword: "Position is required",
  invalidPassword: "Theme content ID is required",
  secondaryAccountExists: "Email is required",
  invalidSecurityCode: "Theme provider type is required",
  accountSocialNotExists: "Phone is required",
  providerInactive: "Target type is required",
  gameIdExists: "Package type is required",
  gameIdNotExists: "Renew term is required",
  parentProviderInactive: "«Социальная платформа неактивна.»",
  betLimitNotExists: "Социальная учетная запись существует.",
  min3Characters: "«Недействительный статус.»",
  invalidBankAccType: "Тот же пароль.",
  senderBankNotExists: "Неверное имя пользователя или пароль.",
  recipientBankNotExists: "Вторичный аккаунт существует.",
  affiliateNotExists: "Неверный код безопасности.",
  redepositedTicket: "Аккаунт в социальных сетях не существует.",
  invalidDepositType: "Провайдер неактивен.",
  affiliateInactive: "Game ID существует.",
  bonusUnavailable: "Game ID не существует.",
  pendingDeposit: "Родительский поставщик неактивен.",
  noOngoingPromotion: "Лимит ставок не существует.",
  iframeNotExists: "Минимум 3 символа.",
  gameMaintenance: "Неверный тип банковского счета.",
  labelInactive: "«Банка отправителя не существует».",
  invalidDomainType: "«Банка-получателя не существует».",
  invalidModule: "Партнер не существует.",
  labelFull: "Возвращенный билет.",
  questionExists: "Неверный тип депозита.",
  questionFull: "Партнер неактивен.",
  questionNotExists: "«Бонус недоступен.»",
  reviewNotExists: "Ожидающий депозит.",
  invalidDomainGroup: "«Никакого постоянного продвижения».",
  invalidDateRange: "IFrame не существует.",
  ipAddressNotExists: "«Обслуживание игры.»",
  marqueeNotExists: "Метка неактивна.",
  invalidAmount: "Неверный тип домена.",
  insufficientBalance: "Недопустимый модуль.",
  minLimitLtParent: "Этикетка заполнена.",
  maxLimitGtParent: "«Вопрос существует».",
  startDateGtEndDate: "Вопрос полный.",
  currencyNotExists: "«Вопроса не существует».",
  currencyExists: "«Обзора не существует».",
  noAccumulateWin: "Неверная доменная группа.",
  invalidSession: "Неверный диапазон дат.",
  sessionExpired: "«IP-адрес не существует.»",
  promotionExists: "«Шатер не существует».",
  invalidCriteria: "Недействительная сумма.",
  promotionNotExists: "«Недостаточный баланс».",
  ticketNotExists: "Минимальный лимит меньше родительского.",
  duplicateDebitRecord: "Максимальный предел больше родительского.",
  duplicateCreditRecord: "Дата начала больше даты окончания.",
  debitRecordNotExists: "«Валюты не существует».",
  minDepositNotMet: "«Валюта существует».",
  duplicateBet: "Нет накопленного выигрыша.",
  invalidProviderCode: "Неверный сеанс.",
  resultExists: "Сеанс истек.",
  unableSPProcess: "«Продвижение существует».",
  authRequired: "Неверные критерии.",
  domainExists: "«Продвижения не существует».",
  multiSelectOption: "«Билета не существует.»",
  invalidDomainFormat: "Дубликат дебетовой записи.",
  noHttpHttps: "«Дубликат кредитной истории».",
  noReservedSubdomain: "«Дебетовая запись не существует».",
  operatorInactive: "«Минимальный депозит не достигнут.»",
  invalidAccountIdFormat: "«Дублирующая ставка.»",
  contentIdRequired: "Неверный код провайдера.",
  themeCodeRequired: "«Результат есть.»",
  themeNameRequired: "Система не может обработать ваш запрос.",
  themeColorRequired: "Требуется код аутентификации.",
  languageRequired: "Домен уже существует.",
  positionRequired: "Пожалуйста, выберите {fname}",
  themeContentIdRequired: "Неверный формат домена",
  emailRequired: "«'https",
  themeProviderTypeRequired: "«Зарезервированный поддомен не допускается. Для использования ссылки для скачивания приложения.»",
  phoneRequired: "«Оператор неактивен»",
  targetTypeRequired: "Неверный формат идентификатора учетной записи",
  packageTypeRequired: "Требуется ID меню",
  renewTermRequired: "Требуется код темы",
  packagePriceRequired: "Имя темы обязательно",
  packageStatusRequired: "Цвет темы обязателен",
  sortKeyRequired: "«Язык обязателен»",
  invalidDomainStatus: "Позиция обязательна",
  invalidCurrency: "Требуется ID содержимого темы",
  invalidThemeCode: "«Электронная почта обязательна»",
  invalidLanguage: "Тип поставщика темы является обязательным",
  invalidPosition: "«Требуется телефон»",
  invalidThemeContent: "Тип цели обязателен",
  allParamsSameAsCurrent: "Тип упаковки обязателен",
  invalidThemeColor: "«Требуется продление срока»",
  invalidCartStatus: "Недействительный статус корзины,",
  invalidThemeProviderType: "Недопустимый тип поставщика темы",
  themeProviderTypeCannotBeUse: "Тип поставщика темы не может быть использован",
  invalidUserStatus: "Неверный статус пользователя",
  packageCannotBeRemove: "Пакет не может быть удален",
  userStatusIsAlrdSuspend: "«Пользователь уже заблокирован»",
  userStatusIsAlrdBlocked: "«Пользователь уже заблокирован»",
  userStatusIsAlrdActive: "Пользователь уже активен,",
  invalidSortType: "Недопустимый тип сортировки",
  startDateBiggerThanEndDate: "«Дата начала больше даты окончания»",
  positionCannotBeUse: "Позиция не может быть использована",
  funcAddContentFailed: "Не удалось добавить контент",
  funcDeleteContentFailed: "Не удалось удалить контент",
  funcUpdateContentFailed: "«Не удалось обновить контент»",
  funcAddThemeFailed: "Не удалось добавить тему",
  funcDeleteThemeFailed: "Не удалось удалить тему",
  funcUpdateThemeFailed: "Не удалось обновить тему",
  funcAddThemeColorFailed: "Не удалось добавить цвет темы,",
  funcDeleteThemeColorFailed: "Не удалось удалить цвет темы",
  funcUpdateThemeColorFailed: "Не удалось обновить цвет темы",
  funcAddLanguageFailed: "Не удалось добавить язык",
  funcDeleteLanguageFailed: "Не удалось удалить язык",
  funcUpdateLanguageFailed: "Не удалось обновить язык",
  funcAddThemeContentFailed: "«Не удалось добавить содержимое темы»",
  funcDeleteThemeContentFailed: "Не удалось удалить содержимое темы",
  funcUpdateThemeContentFailed: "Не удалось обновить содержимое темы",
  funcAddContentPositionFailed: "Не удалось добавить позицию контента",
  funcUpdateContentPositionFailed: "Не удалось обновить позицию контента",
  funcDeleteContentPositionFailed: "Не удалось удалить позицию контента",
  funcAddThemeProviderTypeFailed: "Не удалось добавить тип поставщика темы",
  funcUpdateThemeProviderTypeFailed: "Не удалось обновить тип поставщика темы",
  funcDeleteThemeProviderTypeFailed: "Не удалось удалить тип поставщика темы",
  funcAddPackageFailed: "Не удалось добавить пакет",
  funcUpdatePackageFailed: "Не удалось обновить пакет",
  funcDeletePackageFailed: "Не удалось удалить пакет",
  nicknameRequired: "«Никнейм обязателен»",
  accountStatusRequired: "«Требуется статус учетной записи»",
  contentIdMaxLength50: "Максимальная длина идентификатора меню - 50",
  positionMaxLength10: "Максимальная длина позиции 10",
  contentDescMaxLength200: "Максимальная длина описания содержимого - 200",
  domainStatusRequired: "«Статус домена обязателен»",
  funcAddDomainFailed: "Не удалось добавить домен",
  funcUpdateDomainFailed: "Не удалось обновить домен",
  uploadFailed: "Загрузка не удалась!",
  sortKeyMaxLength50: "Максимальная длина ключа сортировки равна 50",
  invalidSortTypeFormat: "Недопустимый формат типа сортировки",
  invalidPackageId: "Неверный идентификатор пакета",
  invalidAccountStatusFormat: "Неверный формат статуса счета",
  invalidSiteStatusFormat: "Неверный формат статуса сайта",
  invalidPackageStatus: "Неверный статус посылки",
  invalidEmailFormat: "Неверный формат электронной почты",
  invalidPhoneFormat: "«Неверный формат телефона»",
  languageLengthNotInRange: "Длина языка не в диапазоне (2-5)",
  languageDescriptionMaxLength50: "Максимальная длина описания языка составляет 50",
  remarkMaxLength500: "Примечание максимальная длина 500",
  themeProviderTypeMaxLength50: "Максимальная длина типа поставщика темы равна 50",
  themeNameMaxLength50: "Максимальная длина названия темы 50",
  themeColorMaxLength20: "Максимальная длина цвета темы составляет 20",
  noSpace: "Не должен содержать пробелов",
  packageDescEnRequired: "Имя Английский обязательно",
  packageDescEnMaxLength20: "Имя Английский максимальная длина равна 20",
  allParamsIsNull: "Все параметры равны нулю",
  contentCannotBeRemove: "«Контент не может быть удален»",
  contentDetailsRequired: "Требуется подробная информация о содержимом",
  domainCannotBeUse: "«Домен не может быть использован»",
  domainGroupMaxLength20: "Максимальная длина доменной группы составляет 20",
  domainGroupRequired: "Доменная группа обязательна",
  domainNameCannotUpdate: "«Доменное имя не может быть обновлено»",
  domainNameMaxLength400: "Максимальная длина доменного имени 400",
  domainsRequired: "Домены обязательны",
  domainStatusMaxLength20: "Максимальная длина статуса домена равна 20",
  domainTypeMaxLength10: "Максимальная длина доменного типа равна 10",
  funcAddThemeContentGroupFailed: "Не удалось добавить группу содержимого темы",
  funcDeleteThemeContentGroupFailed: "Не удалось удалить группу содержимого темы",
  funcOpsiteUpdateFailed: "Не удалось обновить opsite",
  funcResetAccountPasswordFailed: "«Не удалось сбросить пароль учетной записи»",
  funcSiteLanguageUpsertFailed: "Не удалось улучшить язык сайта",
  funcSiteThemeContentUpsertFailed: "Не удалось довести содержание темы сайта",
  funcSiteThemeUpsertFailed: "Не удалось улучшить тему сайта",
  funcSiteUpdateFailed: "«Не удалось обновить сайт»",
  funcUpdateAccountFailed: "Не удалось обновить аккаунт",
  funcUpdateAccountStatusActiveFailed: "Не удалось обновить статус учетной записи до активного",
  funcUpdateAccountStatusCompanyBlockFailed: "Не удалось обновить статус учетной записи до блокировки компании",
  funcUpdateAccountStatusSuspendFailed: "Обновить статус учетной записи для приостановки не удалось",
  funcUpdateThemeContentGroupFailed: "Не удалось обновить группу содержимого темы",
  invalidBoDomain: "Неверный домен БО",
  invalidOperatorIdFormat: "Неверный формат идентификатора оператора",
  invalidOpsite: "Неверный опсайт",
  invalidOpsiteOperator: "Неверный оператор opsite",
  invalidOpsiteVersion: "Неверная опсайтная версия",
  invalidParentContentInGroup: "Недопустимый родительский контент в группе",
  invalidSite: "Недействительный сайт",
  invalidSiteStatus: "Неверный статус сайта",
  invalidThemeContentGroup: "Неверная группа содержимого темы",
  languageCannotBeUse: "«Языком нельзя пользоваться»",
  languagesRequired: "Языки обязательны",
  logo1Required: "«Логотип обязателен»",
  notSupportMultiDefault: "Мультидефолт не поддерживается",
  operatorIdMaxLength50: "Максимальная длина идентификатора оператора равна 50",
  opsiteNotMatch: "Opsite не совпадает",
  packageTypeMaxLength15: "Максимальная длина типа упаковки составляет 15",
  parentContentIdCannotSameWithContentId: "Родительский идентификатор содержимого не может совпадать с идентификатором содержимого",
  phoneNumberRequired: "Номер телефона обязателен",
  siteIdRequired: "«Требуется идентификатор сайта»",
  siteNameMaxLength50: "Максимальная длина имени сайта равна 50",
  siteNameRequired: "Имя сайта обязательно для выполнения",
  technicalError: "«Техническая ошибка»",
  themeCannotBeRemove: "Тема не может быть удалена",
  themeCodeCannotBeUse: "Код темы не может быть использован",
  themeCodeMaxLength20: "Максимальная длина кода темы составляет 20",
  themeColorCannotBeRemove: "Цвет темы не может быть удален",
  themeColorCannotBeUse: "Цвет темы не может быть использован",
  themeContentCannotBeUse: "«Нельзя использовать содержимое темы»",
  themeContentGroupCannotBeUse: "Нельзя использовать группу содержимого темы",
  themeContentGroupDescriptionMaxLength50: "Максимальная длина описания группы содержимого темы равна 50",
  themeContentGroupMaxLength20: "Максимальная длина группы содержимого темы равна 20",
  themeContentGroupRequired: "Требуется группа содержимого темы",
  themeNameCannotBeUse: "Нельзя использовать название темы",
  userHaventVerifyThisBefore: "Пользователь не проверял это ранее",
  isDefaultTrueRequired: "Язык должен иметь 1 значение по умолчанию",
  accountIdMaxLength50: "Максимальная длина идентификатора пользователя составляет 50",
  headBodyScriptEitherOne: "Пожалуйста, введите Head Script или Body Script",
  alphaOrNum: "Должен быть только алфавит или только цифры",
  phoneValid: "«Пожалуйста, введите действительный номер телефона»",
  permittedAmountRequired: "«Требуется разрешенное количество»",
  ignoreRiskRequired: "«Необходимо игнорировать риск»",
  paymentDescRequired: "Описание платежа обязательно",
  gameTypeRequired: "Тип игры обязателен",
  statusRequired: "Статус обязателен",
  payoutIdRequired: "Требуется идентификатор выплаты",
  commNotExists: "«Комиссии не существует»",
  parentCommNotExists: "«Родительская комиссия не существует»",
  carryOverNotExists: "«Перенос не существует»",
  hotGameExists: "«Горячая дичь уже есть»",
  commSportsExceededParent: "«Комиссия за спорт превысила родительскую»",
  commSlotsExceededParent: "«Комиссия за слоты превысила родительскую»",
  commLivecasinoExceededParent: "«Комиссия за лайв-казино превысила родительскую»",
  commCockfightExceededParent: "«Комиссия за петушиные бои превысила родительскую»",
  commOthersExceededParent: "«Комиссия для других превысила родительскую»",
  hotGameNotExists: "«Горячей игры не существует»",
  noSecurityDeposit: "«Нет страхового фонда»",
  exchangeRateNotExists: "«Обменного курса не существует»",
  insufficientSecurityDeposit: "«Недостаточный фонд обеспечения»",
  duplicateDomain: "Дубликат домена",
  contactEmailNotExists: "«Контактный адрес электронной почты не существует»",
  featuredGameNotExists: "«Призовой игры не существует»",
  newGameNotExists: "«Новой игры не существует»",
  popularGameNotExists: "«Популярной игры не существует»",
  featuredGameExists: "«Фичерная игра уже существует»",
  newGameExists: "«Новая игра уже существует»",
  popularGameExists: "«Популярная игра уже существует»",
  rebateNotExists: "«Рибейта не существует»",
  riskyMember: "Рискованный участник",
  ipRestricted: "«IP защищён»",
  notSupportedBank: "Банк не поддерживается.",
  requestTooFrequent: "«Запрос слишком частый.»",
  paymentOptionNotExists: "«Способ оплаты не существует»",
  earningIdRequired: "Требуется удостоверение личности.",
  ptOnRequired: "PT включен обязательно.",
  ptRequired: "PT обязателен.",
  userIdRequired: "Требуется идентификатор пользователя.",
  businessIdRequired: "Требуется бизнес-идентификатор.",
  subAccountIdRequired: "Требуется идентификатор дополнительной учетной записи.",
  sourceAccountIdRequired: "Требуется идентификатор исходной учетной записи.",
  targetAccountIdRequired: "Требуется идентификатор целевой учетной записи.",
  ticketTaken: "«Билет взят»",
  ticketNotTaken: "«Билет не взят»",
  invalidPt: "Недействительный PT",
  topupIdRequired: "Требуется ID пополнения",
  promotionMemberLogNotExists: "«Журнал участников акции не существует»",
  paymentOptionInactive: "«Способ оплаты неактивен»",
  invalidCartStatusFormat: "Неверный формат статуса корзины",
  requestIncompleted: "«Запрос не выполнен»",
  unknownError: "«Произошла неизвестная ошибка»",
  cartIdRequired: "Требуется ID корзины",
  stepNameRequired: "Имя шага является обязательным",
  invalidCart: "Недействительная корзина",
  invalidStepName: "Неверное имя шага",
  cartHaventSetupComplete: "Корзина не настроена",
  funcCartCreateFailed: "Не удалось создать корзину",
  funcCartUpdateFailed: "Не удалось обновить корзину",
  funcSiteCreateFailed: "Не удалось создать сайт",
  funcCartPurchasedUpdateFailed: "Не удалось обновить корзину куплено,",
  invalidPasswordFormat: "Неверный формат пароля",
  currencyCodeRequired: "«Валюта обязательна»",
  funcCartLanguageUpsertFailed: "Ошибка в использовании языка функциональной тележки",
  invalidUserIdFormat: "Неверный формат идентификатора пользователя",
  operatorPasswordRequired: "Требуется пароль оператора",
  funcCartOperatorInfoUpsertFailed: "Ошибка в работе функции оператора тележки Upsert",
  invalidOperatorPasswordFormat: "Неверный формат пароля оператора",
  operatorIdCannotBeUse: "Нельзя использовать ID оператора",
  siteNameLengthNotInRange: "Длина имени сайта не в диапазоне",
  userIdCannotBeUse: "User ID не может быть использован",
  siteIdAlrdExist: "«ID сайта уже существует»",
  operatorIdAlrdExist: "Идентификатор оператора уже существует,",
  externalIdAlrdExist: "«Внешний идентификатор уже существует»",
  opsiteContentAlrdExist: "«Контент темы сайта уже существует»",
  opsiteLanguageAlrdExist: "«Язык контента сайта уже существует»",
  boAccountAlrdExist: "«Счет БО уже существует»",
  boAccountProfileAlrdExist: "«Профиль аккаунта БО уже существует»",
  boAccountLoginAlrdExist: "«Логин аккаунта БО уже существует»",
  funcCartThemeCodeUpsertFailed: "Не удалось поднять тему тележки",
  funcCartThemeColorUpsertFailed: "Не удалось улучшить цвет корзины",
  funcOpsiteCreateFailed: "«Не удалось создать контент сайта»",
  alphabetValid: "«Должен иметь хотя бы одну прописную и строчную букву»",
  numberValid: "«Должен иметь хотя бы один номер»",
  symbolValid: "Должен иметь хотя бы один символ",
  credentialNotSet: "Учетные данные не установлены,",
  validBankAccFormat: "Недействительный банковский счет No. Формат»",
  moreThan: "{fname} должно быть меньше или равно {fname2},",
  lessThan: "{fname} должно быть больше или равно {fname2}.",
  bankAccountNotAvailable: "«Банковский счет недоступен.»",
  insufficientCredit: "«недостаточный кредит»",
  enableRequired: "Enable is required.",
  funcAddGameFailed: "Не удалось добавить дичь.",
  funcAddGameRewardByBatchFailed: "Не удалось добавить награду за игру по пакетам.",
  funcAddGameRewardFailed: "Не удалось добавить награду за игру.",
  funcAddGameTemplateFailed: "Не удалось добавить шаблон игры.",
  funcAddLayoutTemplateFailed: "Не удалось добавить шаблон макета.",
  funcAddOperatorGameFailed: "Не удалось добавить игру оператора.",
  funcAddOperatorMemberWalletFailed: "Не удалось добавить кошелек участника оператора.",
  funcDeleteGameFailed: "Не удалось удалить игру.",
  funcDeleteGameRewardFailed: "Не удалось удалить награду за игру.",
  funcDeleteGameTemplateFailed: "Не удалось удалить шаблон игры.",
  funcDeleteLayoutTemplateFailed: "Не удалось удалить шаблон макета.",
  funcDeleteOperatorGameFailed: "Не удалось удалить игру оператора.",
  funcUpdateGameFailed: "Не удалось обновить игру.",
  funcUpdateGameRewardFailed: "Не удалось обновить игровую награду.",
  funcUpdateGameTemplateFailed: "Не удалось обновить шаблон игры.",
  funcUpdateLayoutTemplateFailed: "Не удалось обновить шаблон макета.",
  funcUpdateOperatorGameFailed: "Не удалось обновить игру оператора.",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "Не удалось обновить баланс кошелька участника оператора по замороженной сумме,",
  funcUpdateOperatorMemberWalletBalanceFailed: "Не удалось обновить баланс кошелька участника оператора",
  gameCannotBeRemove: "«Игру нельзя удалить.»",
  gameNameCannotBeUse: "Игровое имя не может быть использовано.",
  gameNameMaxLength150: "Название игры должно содержать не более 150 символов.",
  gameRewardCannotBeUse: "«Игровая награда не может быть использована.»",
  gameRewardLimitExceeded: "Превышен лимит игровых наград.",
  gameTemplateExist: "Шаблон игры уже существует.",
  gameTypeMaxLength20: "Тип игры должен состоять не более чем из 20 символов.",
  invalidGame: "Недействительная игра.",
  invalidGameReward: "Недействительная награда за игру.",
  invalidGameTemplate: "Неверный шаблон игры.",
  invalidMemberWallet: "Недействительный кошелек участника.",
  invalidOperatorGame: "Неверная игра оператора.",
  invalidRewardProbability: "Неверная вероятность вознаграждения.",
  invalidTemplate: "Неверный шаблон.",
  maxGameRewardRequired: "Требуется максимальная награда за игру.",
  maxMiniGameRewardRequired: "Требуется максимальная награда за мини-игру.",
  memberWalletAlrdExist: "Кошелек участника уже существует.",
  operatorGameCannotBeUse: "Нельзя использовать игру оператора.",
  operatorGameIdRequired: "Требуется игровой ID оператора.",
  rewardCodeMaxLength20: "Код вознаграждения должен быть не более 20 символов.",
  rewardCodeRequired: "«Требуется код вознаграждения.»",
  rewardCurrencyMaxLength5: "Валюта награды должна быть не более 5 символов.",
  rewardCurrencyRequired: "Требуется валюта вознаграждения.",
  rewardDescriptionMaxLength100: "Описание награды должно быть не более 100 символов.",
  rewardNameMaxLength50: "Название награды должно быть не более 50 символов.",
  rewardProbabilityRequired: "Требуется вероятность вознаграждения.",
  rewardRequired: "«Вознаграждение обязательно.»",
  selectedTemplateMaxLength30: "Выбранный шаблон должен быть не более 30 символов.",
  selectedTemplateRequired: "Выбранный шаблон обязателен.",
  success: "«Успех.»",
  templateCannotBeRemove: "Шаблон не может быть удален.",
  templateCodeCannotBeUse: "Код шаблона не может быть использован.",
  templateCodeMaxLength30: "Код шаблона должен быть не более 30 символов.",
  templateCodeRequired: "Код шаблона обязателен.",
  templateNameMaxLength50: "Имя шаблона должно быть не более 50 символов.",
  tokenRequestRequired: "Запрос токена обязателен.",
  tokenRequired: "«Требуется токен»",
  mustMoreThan: "{fname} должно быть больше {fvalue}",
  mustMoreThanOrEqual: "{fname} должно быть больше или равно {fvalue}",
  tokenInvalid: "Ввод токена недействителен в {key}",
  cashInvalid: "Денежный ввод недействителен в {ключ}",
  atLeastOneRequired: "«Хотя бы один обязателен»",
  cash1To7Required: "«Требуются наличные от 1 до 7»",
  cash1To6Required: "«Требуются наличные от 1 до 6»",
  cash1To5Required: "«Требуются наличные от 1 до 5»",
  cash1To4Required: "«Требуются наличные от 1 до 4»",
  cash1To3Required: "«Требуются наличные от 1 до 3»",
  cash1To2Required: "«Требуется оплата наличными от 1 до 2»",
  cash1Required: "«Требуется 1 наличный»",
  token1To7Required: "«Требуется токен от 1 до 7»",
  token1To6Required: "«Требуется токен от 1 до 6»",
  token1To5Required: "«Требуется токен от 1 до 5»",
  token1To4Required: "«Требуется токен от 1 до 4»",
  token1To3Required: "«Требуется токен от 1 до 3»",
  token1To2Required: "«Требуется токен от 1 до 2»",
  token1Required: "«Токен 1 обязателен»",
  cycleRequired: "«Цикл обязателен»",
  targetAmountRequired: "«Требуется целевая сумма»",
  gamifyIdRequired: "«Требуется идентификатор вознаграждения»",
  gamifyMemberProcessed: "«Участник с вознаграждением обработан»",
  gamifyNotExists: "«Награды не существует»",
  gamifyInactive: "«Награда неактивна»",
  invalidCycle: "«Недействительный цикл»",
  memberIdRequired: "Требуется идентификатор пользователя",
  memberIdMaxLength50: "ID участника не должен превышать 50 символов",
  funcAddGameWalletFreeCreditFailed: "Не удалось добавить бесплатный кредит на игровой кошелек,",
  mustHaveBothAlphaNumOnly: "«Используйте только буквы и цифры, по крайней мере по одной из них».",
  setupGameRewardBeforeEnable: "Пожалуйста, настройте игровую награду перед ее активацией.",
  rewardProbabilityMustNotAllZero: "«Вероятности вознаграждения не должны быть равны нулю».",
  totalRewardProbabilityCannotOver100: "Общая вероятность вознаграждения не может превышать 100.",
  credential1To2Required: "Требуется квалификация от 1 до 2.",
  credential1To4Required: "Требуется квалификация от 1 до 4.",
  newRemarkRequired: " — Ремарка обязательна.",

  notSupportedWithdrawalPG: "Платёжный шлюз для вывода средств не поддерживается.",
};